export const testAttributes = {
    MORTGAGE_RATE_PAGE: 'mortgage_rate_page',
}